module.exports = __webpack_public_path__ + "img/the-wright_brothers.59e7cce9.jpg";